import keyBy from 'lodash/keyBy';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import RichTextViewer from '@/components/RichTextViewer';
import { CorrectMtfPairingsFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuestionPerformance';
import { QuizPlayerQuestionContentFragment } from '@/modules/corporate/modules/quiz/views/QuizPlayer/graphql/fragments/generated/QuizPlayerQuestionContent';

import AnswerMap from '../../../fill-in-the-blanks/QuestionReview/AnswerMap';

interface CorrectAnswersProps {
  className?: string;
  mtfComponent: QuizPlayerQuestionContentFragment['mtfComponent'];
  correctMtfPairings: CorrectMtfPairingsFragment[];
}

const CorrectAnswers: React.FC<CorrectAnswersProps> = ({
  mtfComponent,
  correctMtfPairings,
  className,
}) => {
  const { t } = useTranslation();
  const rightElementsById = keyBy(mtfComponent?.distractedRightElements || [], 'id');
  const correctAnswersByLeftElementId = keyBy(correctMtfPairings, 'leftElementId');

  return (
    <Stack
      className={cn(
        'p-12 rounded-6 border border-border-success-dark bg-bg-success-light',
        className,
      )}
      direction="col"
      gapY={12}>
      <Typography color="text-text-success-dark" variant="body-short-02">
        {t('QuizPlayer:CorrectAnswer')}
      </Typography>
      {mtfComponent?.leftElements.map((component) => {
        const rightElementAnswer = correctAnswersByLeftElementId[component.id]?.rightElementIds;
        const responseText = rightElementAnswer.length
          ? rightElementsById[rightElementAnswer[0]]?.text
          : undefined;

        return (
          <AnswerMap
            key={component.id}
            labelLeft={<RichTextViewer html={component.text} variant="body-short-02" />}
            labelRight={
              responseText ? (
                <RichTextViewer html={responseText} variant="body-short-02" />
              ) : undefined
            }
          />
        );
      })}
    </Stack>
  );
};

export default CorrectAnswers;
